import styles from './legalPage.module.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const CguPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.topbar}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <span className={styles.topbarTitle}>Conditions Générales d'Utilisation</span>
      </div>

      <div className={styles.container}>
        <div className={styles.cover}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <img src={require('../images/logo.jpeg')} alt="Agora Logo" style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
            <h1 className={styles.appName} style={{ margin: 0 }}>agora</h1>
          </div>
          <h2 className={styles.docTitle}>Conditions Générales d'Utilisation</h2>
          <p className={styles.docSubtitle}>Plateforme de débats et d'échanges</p>
          <p className={styles.docDate}>Dernière mise à jour : 4 avril 2026</p>
        </div>

        <Section title="1. Objet et acceptation">
          <P>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation de la plateforme Agora, un espace dédié à la confrontation d'idées, aux débats constructifs et à la liberté d'expression citoyenne.</P>
          <P>En créant un compte ou en utilisant Agora, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser la plateforme.</P>
        </Section>

        <Section title="2. Accès au service">
          <SubSection title="2.1 Conditions d'inscription">
            <P>Pour créer un compte Agora, vous devez :</P>
            <Ul items={[
              'Être âgé(e) d\'au moins 15 ans',
              'Fournir une adresse e-mail valide et vérifiable',
              'Choisir un nom d\'utilisateur et un mot de passe conformes aux règles de la plateforme',
            ]} />
          </SubSection>
          <SubSection title="2.2 Unicité du compte">
            <P>Chaque utilisateur ne peut posséder qu'un seul compte. La création de comptes multiples est interdite et peut entraîner la suspension de l'ensemble des comptes concernés.</P>
          </SubSection>
          <SubSection title="2.3 Responsabilité des identifiants">
            <P>Vous êtes seul(e) responsable de la confidentialité de vos identifiants de connexion. Toute activité effectuée depuis votre compte vous est attribuable. En cas de compromission de votre compte, informez-nous immédiatement.</P>
          </SubSection>
        </Section>

        <Section title="3. Règles de conduite et contenu">
          <SubSection title="3.1 Contenu autorisé">
            <P>Agora est conçu pour favoriser les échanges entre étudiants togolais. Sont autorisés :</P>
            <Ul items={[
              'Débats sur des sujets d\'actualité, de société ou de culture',
              'Arguments constructifs (Pour ou Contre) illustrés ou textuels',
              'Partage d\'informations et d\'événements communautaires',
              'Discussions respectueuses favorisant l\'échange d\'idées',
            ]} />
          </SubSection>
          <SubSection title="3.2 Contenu interdit">
            <P>Il est strictement interdit de publier, partager ou diffuser :</P>
            <Ul items={[
              'Tout contenu à caractère haineux, discriminatoire, raciste ou xénophobe',
              'Contenu pornographique ou à caractère sexuel explicite',
              'Informations personnelles d\'autrui sans son consentement (doxing)',
              'Contenus portant atteinte aux droits d\'auteur ou à la propriété intellectuelle',
              'Fausses informations ou désinformation délibérée',
              'Contenu encourageant la violence, l\'automutilation ou le suicide',
              'Spam, publicité non sollicitée ou contenu commercial non autorisé',
              'Tout contenu illégal au regard du droit togolais',
              'Usurpation d\'identité ou représentation frauduleuse',
            ]} />
          </SubSection>
          <SubSection title="3.3 Comportement interdit">
            <Ul items={[
              'Harcèlement, intimidation ou cyberbullying envers d\'autres utilisateurs',
              'Tentatives de piratage, d\'accès non autorisé ou d\'exploitation de failles',
              'Utilisation de bots, scripts ou outils automatisés sans autorisation',
              'Manipulation des mécanismes de signalement à des fins malveillantes',
            ]} />
          </SubSection>
        </Section>

        <Section title="4. Propriété intellectuelle">
          <SubSection title="4.1 Contenus des utilisateurs">
            <P>Vous conservez la propriété de tout contenu que vous publiez sur Agora. En publiant du contenu, vous accordez à Agora une licence non exclusive, mondiale et gratuite pour afficher, reproduire et distribuer ce contenu dans le cadre du fonctionnement de la plateforme.</P>
          </SubSection>
          <SubSection title="4.2 Plateforme Agora">
            <P>La plateforme Agora, son code source, son design et ses fonctionnalités sont la propriété exclusive de leurs créateurs. Toute reproduction, modification ou utilisation non autorisée est interdite.</P>
          </SubSection>
        </Section>

        <Section title="5. Modération et signalement">
          <SubSection title="5.1 Signalement">
            <P>Tout utilisateur peut signaler un contenu qu'il estime contraire aux présentes CGU via le bouton de signalement disponible sur chaque publication. Les signalements sont traités par notre équipe de modération.</P>
          </SubSection>
          <SubSection title="5.2 Sanctions">
            <P>En cas de violation des présentes CGU, Agora se réserve le droit de :</P>
            <Ul items={[
              'Supprimer le contenu non conforme',
              'Émettre un avertissement à l\'utilisateur concerné',
              'Suspendre temporairement le compte',
              'Bannir définitivement le compte',
            ]} />
            <P>Les décisions de modération sont prises discrétionnairement par l'équipe Agora. En cas de désaccord, vous pouvez nous contacter.</P>
          </SubSection>
        </Section>

        <Section title="6. Messagerie privée">
          <P>La messagerie privée d'Agora est destinée à des échanges personnels entre utilisateurs. Il est interdit d'utiliser la messagerie pour du spam, du harcèlement ou toute activité contraire aux présentes CGU. Agora ne lit pas le contenu des messages privés, sauf en cas d'obligation légale.</P>
        </Section>

        <Section title="7. Disponibilité du service">
          <P>Agora s'efforce d'assurer la disponibilité de la plateforme 24h/24 et 7j/7. Cependant, des interruptions peuvent survenir pour maintenance, mises à jour ou raisons techniques. Nous ne pouvons être tenus responsables des pertes liées à une indisponibilité du service.</P>
        </Section>

        <Section title="8. Limitation de responsabilité">
          <P>Agora est une plateforme d'hébergement de contenu. Nous ne sommes pas responsables :</P>
          <Ul items={[
            'Du contenu publié par les utilisateurs',
            'Des interactions entre utilisateurs',
            'Des dommages directs ou indirects résultant de l\'utilisation de la plateforme',
            'De la perte de données due à des circonstances techniques imprévues',
          ]} />
          <P>Vous utilisez Agora sous votre entière responsabilité.</P>
        </Section>

        <Section title="9. Données personnelles">
          <P>Le traitement de vos données personnelles est régi par notre{' '}
            <a href="/politique-confidentialite" className={styles.link}>Politique de Confidentialité</a>.
            En acceptant ces CGU, vous acceptez également notre Politique de Confidentialité.
          </P>
        </Section>

        <Section title="10. Modification des CGU">
          <P>Agora se réserve le droit de modifier les présentes CGU à tout moment. Les modifications importantes vous seront notifiées via la plateforme. La poursuite de l'utilisation d'Agora après notification vaut acceptation des nouvelles CGU.</P>
        </Section>

        <Section title="11. Droit applicable et juridiction">
          <P>Les présentes CGU sont soumises au droit de la République togolaise. En cas de litige, et après tentative de résolution amiable, les tribunaux compétents du Togo seront saisis.</P>
        </Section>

        <Section title="12. Contact">
          <P>Pour toute question, réclamation ou signalement relatif aux présentes CGU :</P>
          <P><strong>Email :</strong> contact@agora-app.com</P>
          <P><strong>Application :</strong> Agora — Plateforme de débats et d'échanges</P>
        </Section>

        <div className={styles.footer}>
          <p>En utilisant Agora, vous confirmez avoir lu, compris et accepté les présentes Conditions Générales d'Utilisation.</p>
        </div>
      </div>
    </div>
  );
};

// ── Composants internes ──────────────────────────────────────
const Section = ({ title, children }) => (
  <section className={styles.section}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    {children}
  </section>
);

const SubSection = ({ title, children }) => (
  <div className={styles.subSection}>
    <h3 className={styles.subSectionTitle}>{title}</h3>
    {children}
  </div>
);

const P = ({ children }) => <p className={styles.paragraph}>{children}</p>;

const Ul = ({ items }) => (
  <ul className={styles.list}>
    {items.map((item, i) => <li key={i}>{item}</li>)}
  </ul>
);

export default CguPage;